import React, { FC } from 'react';
import classNames from 'classnames';
import { Button } from 'ncoded-component-library';

import './SearchEmptyState.styles.scss';

type SearchEmptyStateProps = {
  className?: string;
  title: string;
  description?: string;
  action: { label: string; onClick: () => void };
};

const SearchEmptyState: FC<SearchEmptyStateProps> = (props) => {
  const { className, title, description, action } = props;

  const classes = classNames('search-empty-state', className);

  return (
    <div className={classes}>
      <p className="search-empty-state__title">{title}</p>

      {description && (
        <p className="search-empty-state__description">{description}</p>
      )}

      <Button variant="outline" onClick={action.onClick}>
        {action.label}
      </Button>
    </div>
  );
};

export default SearchEmptyState;
